<div class="col-sm-12 col-md-3" id="mmm-first-column">
  <pru-marketing-content-fields [columnContent]="columnContent[0]" 
                                [marketingTheme]="marketingTheme" 
                                [shortTitlePresent]="hasShortTitle"
                                [longTitlePresent]="hasLongTitle"
                                [longShortTitle] ="hasLongShortTitle"
                                [preTitlePresent] ="hasPreTitle"
                                [retirementLink]="retirementLink" >
  </pru-marketing-content-fields>
</div>
<div class="col-sm-12 col-md-6" id="mmm-second-column">
  <pru-marketing-content-fields  [columnContent]="columnContent[1]" 
                                 [marketingTheme]="marketingTheme" 
                                 [shortTitlePresent]="hasShortTitle"
                                 [longTitlePresent]="hasLongTitle"
                                 [longShortTitle] ="hasLongShortTitle"
                                 [preTitlePresent] ="hasPreTitle" 
                                 [retirementLink]="retirementLink">
  </pru-marketing-content-fields>
</div>
<div class="col-sm-12 col-md-3" id="mmm-third-column">
  <pru-marketing-content-fields  [columnContent]="columnContent[2]" 
                                 [marketingTheme]="marketingTheme" 
                                 [shortTitlePresent]="hasShortTitle"
                                 [longTitlePresent]="hasLongTitle"
                                 [longShortTitle] ="hasLongShortTitle"
                                 [preTitlePresent] ="hasPreTitle"
                                 [retirementLink]="retirementLink" >
  </pru-marketing-content-fields>
</div>
